import { Logger } from '../../../../generic/utils';
import { WrapperFunctionsDefinited } from './interfaces';
import { wrapperIdentifier } from './common';

new Logger(wrapperIdentifier);

export const wrapperFunctions: WrapperFunctionsDefinited = [];
